import { prop, applySpec } from 'ramda';

export default applySpec({
	id: prop('ID'),
	text: prop('NAME'),
});
